import type { IUserMilestone } from '../../IUserMilestone';

/**
 * Set when retailer sees modal showing unlocked Faire benefits after converting to paid shopify plan.
 */
export const SHOPIFY_ONBOARDING_BENEFITS_MODAL_SEEN =
  'SHOPIFY_ONBOARDING_BENEFITS_MODAL_SEEN' as IUserMilestone.RetailerMilestone;
